<p-card styleClass="shadow-sm">
  <div class="flex flex-col items-center justify-center text-center p-2">
    <i [class]="icon + ' text-3xl mb-2 ' + iconColor"></i>
    <span class="text-xl font-normal">{{ value }}</span>
    <span class="text-sm text-surface-500 dark:text-surface-400">{{ label }}</span>
  </div>
</p-card>
